import styled from 'styled-components/macro';
import { SectionFooter } from '../Section';
import media from '../../styles/media';
import { grayDividerLighter } from '../../styles/colors';

export const StyledSectionFooter = styled(SectionFooter)`
  flex-wrap: wrap;
  ${media.desktop`
    border-top: 1px solid ${grayDividerLighter};
    padding-top:20px;
    margin-top: 20px;
  `}
`;

export const RadioButtonsWrapper = styled.div`
  display: flex;

  flex: 0 1 100%;
  ${media.desktop`
    flex: 0 1 50%;
  `}

  > div {
    flex-grow: 1;
  }
`;

export const Text = styled.p`
  flex-grow: 1;
  flex: 0 1 100%;
  margin-bottom: 10px;
  ${media.desktop`
    flex: 0 1 50%;
    margin-bottom: 0;
  `}
`;
